import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";

import labels from "../../../../../constants/displayFields";
import Input from "../../../../../components/form/Input";
import Select from "../../../../../components/form/Select";
import DimensionsField from "../../../../../views/capture/DimensionsField";
import WeightField from "../../../../../views/capture/WeightField";
import { getActiveSortedPalletTypes } from "../../../../../utils/palletHelpers";
import { getActiveSortedUnitTypes } from "../../../../../utils/unitHelpers";
import { getSquareFootageTypeOptions } from "../../../../../utils/squareFootageHelpers";
import { getMissingBillingFields } from "../../../../../utils/billingFieldsHelpers";

export default function BillingFields({
  project,
  shipment,
  disabledForm,
  fullWidth,
  asset,
  handleUpdateAssetField,
}) {
  const missingFields = getMissingBillingFields(project, shipment);
  const md = fullWidth ? 12 : 4;
  const palletTypeOptions = getActiveSortedPalletTypes(project?.palletTypes || [])
    .filter((pt) => pt.id)
    .map((pt) => [pt.id, pt.name]);
  const unitTypeOptions = getActiveSortedUnitTypes(project?.unitTypes || [])
    .filter((ut) => ut.id)
    .map((ut) => [ut.id, ut.name]);
  const resolvedUnitTypeOptions = unitTypeOptions.length > 0
    ? unitTypeOptions
    : [["standard_unit", "Standard Unit"]];
  const squareFootageTypeOptions = getSquareFootageTypeOptions(project?.squareFootageTypes || []);

  if (missingFields.length === 0) {
    return null;
  }

  const display = missingFields.reduce((acc, field) => {
    acc[field] = true;
    return acc;
  }, {});

  return (
    <Card sx={{ height: "100%", overflow: "visible" }}>
      <CardContent>
        <Box mt={-1} mb={1}>
          <Typography fontWeight={500} fontSize={18}>
            Billing Fields
          </Typography>
        </Box>
        <Grid container spacing={1}>
          {display.pallet_type && (
            <Grid size={{ xs: 12, md: md }}>
              <Select
                size="small"
                name="palletType"
                label={labels.pallet_type}
                disabled={disabledForm}
                options={palletTypeOptions}
                showNAButton={false}
              />
            </Grid>
          )}
          {display.unit_type && (
            <Grid size={{ xs: 12, md: md }}>
              <Select
                size="small"
                name="unitType"
                label={labels.unit_type}
                disabled={disabledForm}
                options={resolvedUnitTypeOptions}
                showNAButton={false}
              />
            </Grid>
          )}
          {display.square_footage_type && (
            <Grid size={{ xs: 12, md: md }}>
              <Select
                size="small"
                name="squareFootageType"
                label={labels.square_footage_type}
                disabled={disabledForm}
                options={squareFootageTypeOptions}
                showNAButton={false}
              />
            </Grid>
          )}
          {display.dimensions && (
            <Grid size={{ xs: 12, md: md }}>
              <DimensionsField
                name="dimensions"
                disabled={disabledForm}
                asset={asset}
                handleUpdateAssetField={handleUpdateAssetField}
              />
            </Grid>
          )}
          {display.square_footage && (
            <Grid size={{ xs: 12, md: md }}>
              <Input
                type="autoExpand"
                name="squareFootage"
                label={labels.square_footage}
                disabled={disabledForm}
              />
            </Grid>
          )}
          {display.cubic_footage && (
            <Grid size={{ xs: 12, md: md }}>
              <Input
                type="autoExpand"
                name="cubicFootage"
                label={labels.cubic_footage}
                disabled={disabledForm}
              />
            </Grid>
          )}
          {display.weight && (
            <Grid size={{ xs: 12, md: md }}>
              <WeightField
                name="weight"
                label={labels.weight}
                disabled={disabledForm}
                asset={asset}
                handleUpdateAssetField={handleUpdateAssetField}
                inputProps={{ inputMode: "decimal" }}
              />
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
}
